export const PREFIX_URL = '/administradores';
export const generateURL = (url: string) => `${PREFIX_URL}${url}`;
